import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const emptyLiquidationsList = () => ({
  'type': ActionTypes.EMPTY_LIQUIDATIONS_LIST,
});

export const fetchLiquidationsList = (type) => {
  const importType = type === 'vehicles' ? 'VEHICULOS' : 'REPUESTOS';
  return apiActionCreator({
    'endpoint': `/importations/liquidations?type=${importType}`,
    'authenticated': true,
    'types': [
      ActionTypes.LOADING_LIQUIDATIONS_LIST,
      ActionTypes.LOADED_LIQUIDATIONS_LIST,
      [
        ActionTypes.LOADED_LIQUIDATIONS_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchLiquidationsDetail = (invoice) => apiActionCreator({
  'endpoint': `/importations/liquidations/detail/${invoice}`,
  'authenticated': true,
  'types': [
    ActionTypes.LOADING_LIQUIDATIONS_DETAIL,
    ActionTypes.LOADED_LIQUIDATIONS_DETAIL,
    [
      ActionTypes.LOADED_LIQUIDATIONS_DETAIL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
